// extracted by mini-css-extract-plugin
export default {"bouncing-loader":"bouncingdotsloader_bouncing-loader__DVyx3"};